/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchProductsRequestInnerAllOfAllergensInner } from './PatchProductsRequestInnerAllOfAllergensInner';
import {
    PatchProductsRequestInnerAllOfAllergensInnerFromJSON,
    PatchProductsRequestInnerAllOfAllergensInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfAllergensInnerToJSON,
    PatchProductsRequestInnerAllOfAllergensInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfAllergensInner';

/**
 * 
 * @export
 * @interface PatchModifierRequest
 */
export interface PatchModifierRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchModifierRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchModifierRequest
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchModifierRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchModifierRequest
     */
    priceImpact?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchModifierRequest
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchModifierRequest
     */
    kitchenName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchModifierRequest
     */
    shortName?: string;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfAllergensInner>}
     * @memberof PatchModifierRequest
     */
    allergens?: Array<PatchProductsRequestInnerAllOfAllergensInner>;
}

/**
 * Check if a given object implements the PatchModifierRequest interface.
 */
export function instanceOfPatchModifierRequest(value: object): value is PatchModifierRequest {
    return true;
}

export function PatchModifierRequestFromJSON(json: any): PatchModifierRequest {
    return PatchModifierRequestFromJSONTyped(json, false);
}

export function PatchModifierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchModifierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'priceImpact': json['priceImpact'] == null ? undefined : json['priceImpact'],
        'color': json['color'] == null ? undefined : json['color'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'allergens': json['allergens'] == null ? undefined : ((json['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerFromJSON)),
    };
}

export function PatchModifierRequestToJSON(json: any): PatchModifierRequest {
    return PatchModifierRequestToJSONTyped(json, false);
}

export function PatchModifierRequestToJSONTyped(value?: PatchModifierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'priceImpact': value['priceImpact'],
        'color': value['color'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'allergens': value['allergens'] == null ? undefined : ((value['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerToJSON)),
    };
}

